import { Direction, NodeData } from './types';

export class FlashMapNodeModel {
  id: string;
  index: number;
  topic: string;
  data: NodeData;
  isroot: boolean;
  parent: FlashMapNodeModel | null;
  direction: Direction;
  expanded: boolean;
  children: FlashMapNodeModel[] = [];
  _data: {
    view?: {
      abs_x: number;
      abs_y: number;
      width: number;
      height: number;
    };
  } = {};

  constructor(
    id: string,
    index: number,
    topic: string,
    data: NodeData = {},
    isroot = false,
    parent: FlashMapNodeModel | null = null,
    direction: Direction = Direction.RIGHT,
    expanded = true
  ) {
    this.id = id;
    this.index = index;
    this.topic = topic;
    this.data = data;
    this.isroot = isroot;
    this.parent = parent;
    this.direction = direction;
    this.expanded = expanded;
  }

  getLocation(): { x: number; y: number } {
    const vd = this._data.view;
    return {
      x: vd?.abs_x ?? 0,
      y: vd?.abs_y ?? 0,
    };
  }

  getSize(): { w: number; h: number } {
    const vd = this._data.view;
    return {
      w: vd?.width ?? 0,
      h: vd?.height ?? 0,
    };
  }

  static compare(node1: FlashMapNodeModel, node2: FlashMapNodeModel): number {
    const i1 = node1.index;
    const i2 = node2.index;

    if (i1 >= 0 && i2 >= 0) {
      return i1 - i2;
    } else if (i1 === -1 && i2 === -1) {
      return 0;
    } else if (i1 === -1) {
      return 1;
    } else if (i2 === -1) {
      return -1;
    }
    return 0;
  }

  static isInheritedFrom(parentNode: FlashMapNodeModel | null, node: FlashMapNodeModel): boolean {
    if (!parentNode || !node) {
      return false;
    }
    if (node.id === parentNode.id) {
      return true;
    }
    if (node.isroot) {
      return true;
    }
    let pid = node.id;
    let p = node;
    while (p?.parent) {
      p = p.parent;
      if (p.id === parentNode.id) {
        return true;
      }
    }
    return false;
  }

  static isNode(node: unknown): node is FlashMapNodeModel {
    return node instanceof FlashMapNodeModel;
  }
}

